import { Params, useMatches } from "react-router-dom";
import { Breadcrumb } from "antd";
import { ItemType } from "antd/es/breadcrumb/Breadcrumb";
import { observer } from "mobx-react-lite";

import { CrumbHandle } from "@/app/routing/types";
import { UIFlatIcon } from "@/shared/ui/ui-flat-icon";
import { filterBoolean } from "@/shared/utils/array";

import { BreadCrumbItem } from "./bread-crumb-item";
import { CEXBotBreadCrumb } from "./cex-bot-breadcrumb";
import { MarketBreadCrumb } from "./market-breadcrumb";
import { PartyBreadCrumb } from "./party-breadcrumb";
import { BreadCrumbSelectMenuType, BreadCrumbItemProps } from "./types";

interface IMatches {
	id: string;
	pathname: string;
	params: Params<string>;
	data: unknown;
	handle: unknown;
}

const DEFAULT_ITEMS: ItemType[] = [
	{
		path: "/",
		title: (
			<span className="inline-flex gap-4 items-center">
				<UIFlatIcon name="fi-rr-house-window" />
				Parties
			</span>
		),
	},
];

const breadCrumbMap: Record<BreadCrumbSelectMenuType, (props: BreadCrumbItemProps) => JSX.Element> =
	{
		parties: PartyBreadCrumb,
		markets: MarketBreadCrumb,
		"cex-bots": CEXBotBreadCrumb,
	};

const RenderItem = ({
	route,
	paths,
}: {
	route: ItemType & { selectMenuType?: BreadCrumbSelectMenuType };
	paths: string[];
}) => {
	const { selectMenuType, ...restRoute } = route;

	if (selectMenuType) {
		const BreadCrumbComponent = breadCrumbMap[selectMenuType];
		return <BreadCrumbComponent route={restRoute} paths={paths} />;
	}

	return <BreadCrumbItem route={restRoute} paths={paths} />;
};

export const BreadCrumbs = observer(() => {
	const matches: IMatches[] = useMatches();
	const crumbs = filterBoolean(matches.map((match) => (match?.handle as CrumbHandle)?.crumb));

	const items = crumbs.length ? [...DEFAULT_ITEMS, ...crumbs] : DEFAULT_ITEMS;

	return (
		<Breadcrumb
			itemRender={(route, _params, _routes, paths) => <RenderItem route={route} paths={paths} />}
			items={items}
		/>
	);
});
